// extracted by mini-css-extract-plugin
module.exports = {"parent":"LoadingIndicator-styles-module--parent--2rseO"};